import axios from '../index'

function listMgrInfo(params) {
	return axios.get('/api/admin/listMgrInfo', params)
}
function getMgrInfo(params) {
	return axios.get('/api/admin/getMgrInfo', params)
}
function insertMgrInfo(formdata) {
  return axios({
    method: "post",
    url: "/api/admin/insertMgrInfo",
    data: formdata
  });
}
function updateMgrInfo(formdata) {
  return axios({
    method: "post",
    url: "/api/admin/updateMgrInfo",
    data: formdata
  });
}
function updateMgrInfo2(formdata) {
    return axios({
        method: "post",
        url: "/api/admin/updateMgrInfo2",
        data: formdata
    });
}
function updateMgrInfo3(formdata) {
  return axios({
    method: "post",
    url: "/api/admin/updateMgrInfo3",
    data: formdata
  });
}
function deleteMgrInfo(params) {
	return axios.post('/api/admin/deleteMgrInfo', null, params)
}
export default {
	listMgrInfo,
	getMgrInfo,
	insertMgrInfo,
	updateMgrInfo,
  updateMgrInfo2,
  updateMgrInfo3,
	deleteMgrInfo,

}
